import styled from "styled-components";

import { SortComponent } from "app/components/React/Table/headerCells/DefaultCellHeader";
import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import { translate } from "app/filters/i18nFilter";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Bullet } from "pro-features/styled components/StyledLabel/Bullet";

import type { ITableHeaderCellProps } from "../interfaces/ITableCellProps";
interface ICellHeaderRightAlignedWithLegendProps
    extends Partial<
        Pick<ITableHeaderCellProps, "sortDirection" | "sortable" | "displayName" | "field" | "displayTooltip">
    > {
    bulletColor?: string;
}

const HeaderWrapper = styled(FlexRow)`
    flex-direction: row-reverse;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
`;

const BulletContainer = styled.div`
    display: flex;
    padding-right: 4px;
`;

export const CellHeaderRightAlignedWithLegend = (props: ICellHeaderRightAlignedWithLegendProps) => {
    const {
        sortDirection,
        sortable,
        // @ts-ignore FIXME: strict migration - Argument of type 'string | undefined' is not assignable to parameter of type 'string | string[]' — props.field is optional but translate requires a key
        displayName = translate(props.field),
        displayTooltip,
        bulletColor,
    } = props;
    return (
        <HeaderWrapper data-automation="header-cell">
            <PlainTooltip
                text={displayTooltip}
                enabled={!!displayTooltip}
            >
                <span
                    data-automation="header-cell.text"
                    className={"headerCell-text u-truncate"}
                >
                    {displayName}
                </span>
            </PlainTooltip>
            {bulletColor ? (
                <BulletContainer>
                    <Bullet color={bulletColor} />
                </BulletContainer>
            ) : null}
            {sortable ? (
                // @ts-ignore FIXME: strict migration - Type 'string | undefined' is not assignable to type 'string' — sortDirection is optional but SortComponent's prop is required
                <SortComponent sortDirection={sortDirection} />
            ) : null}
        </HeaderWrapper>
    );
};
CellHeaderRightAlignedWithLegend.displayName = "CellHeaderRightAlignedWithLegend";
